import { v4 as uuidv4 } from 'uuid';
import Doitright from '../images/doitright.png';
import Stract from '../images/stract.png';
import Biffle from '../images/biffle.png';
import RWA from '../images/rwa.png';
import Iching from '../images/iching.png';
import Iosnake from '../images/iosnake.jpeg';

const projects = [
  {
    id: uuidv4(),
    name: 'Snake.io',
    desc:
      'A websockets based classical snakes game where people can create a private room and play multiplayers and their friends can also spectate an ongoing game',
    img: Iosnake,
    url: 'https://iosnake.netlify.app/'
  }, {
    id: uuidv4(),
    name: 'Stract',
    desc:
      'A mongoDB and flutter based stickers app consisting of 1000+ stickers for various social messaging apps.',
    img: Stract,
    url: 'https://play.google.com/store/apps/details?id=com.cobble.stract&hl=en_IN&gl=US'
  },
  {
    id: uuidv4(),
    name: 'Biffle',
    desc:
      'It is a social media chatting appliction based on flutter and firebase',
    img: Biffle,
    url: 'https://drive.google.com/drive/u/0/folders/1YAcMJLvsZ-yI-JtBi4xdC-49gLJC9noV'
  },
  {
    id: uuidv4(),
    name: 'Do it right',
    desc:
      'Do It Right is a fitness app that leverages augmented reality. It creates a three dimensional model of a person portraying how a particular exercise should be done.',
    img: Doitright,
    url: 'https://ojasvishaklya.github.io/do_it_right/'
  },
  {
    id: uuidv4(),
    name: "Iching",
    desc:
      'The cobble I Ching or Yi Jing app is based on the Book of Changes. Which uses statistics and probability to predict answers to some important questions of life. This app helps to automate the process',
    img: Iching,
    url: 'https://play.google.com/store/apps/details?id=com.cobble.i_ching&hl=en_IN&gl=US'
  },
  {
    id: uuidv4(),
    name: 'RWA',
    desc:
      'A one search solution to the most common parking problem, Cobble RWA finishes the tedious task of finding the owner of the car in a few seconds and hence, no more knocking on doors or searching for the guard. So let us take your stress away and enjoy the ride ahead.',
    img: RWA,
    url: 'https://play.google.com/store/apps/details?id=com.cobble.rwa&hl=en_IN&gl=US'
  },
];

export default projects;
